module.exports = __webpack_public_path__ + "static/img/gw.be7d9fe1.svg";